import React, { useState, useEffect, useRef } from 'react';
import styles from '../../styles/Recepti.module.css';
import ItemRecepti from '../ApplicationContent/ItemRecepti';

import * as firebase from 'firebase/app';

//let data: any;
const Recepti = (props) => {

    const [allMedicine, setAllMedicine] = useState();

    let userId = props.data // getting UID
    //let ind = props.idata // getting index WHY ??

    console.log(userId);
    const isCurrent = useRef(true);

    useEffect(() => {
        return () => {
        isCurrent.current = false;
        }
    }, [])

    const getDataFirebase = (userId) => {
        //let array: any;
        let data;
        // getting data from location for MEDICINE
        let getData = firebase.database().ref('/users/' + userId + '/prescriptions');
        getData.on('value', function(snapshot) {
            console.log(snapshot.val());
            console.log("data?FB-recepti")
            data = snapshot.val();
            if (data !== null) {
                // getting data to correct form ID:, DATe, Medicine, howMuch, ManyTImes:
                const allMedicineArray = Object.keys(data).map( key => {
                    return  { 
                        id: key, 
                        date: data[key].date, 
                        med: data[key].med,
                        howM: data[key].howM,
                        manyT: data[key].manyT 
                    };
                })
                //set in reverse order so the last input is 1 in line
                //checking for componenet is mounted !!
                if (isCurrent.current) { setAllMedicine(allMedicineArray.reverse()) }  
            } 
        })
        // removes listeners from firebase database - didnt check if it works
        //getData.off("value");
    }
//
  // u need to pass [userId] so it rerenders when prop.data changes !!
  useEffect(() => {
    getDataFirebase(userId)
  }, [userId])

  

  return  (
    <div className={styles.Desktop}>
      <div className={styles.MainTitle}>
        <p>Recepti</p>
      </div>
      <div className={styles.List}>
        <ItemRecepti data={allMedicine} />
      </div>
    </div>
  ) 
}

export default Recepti;
